import { forwardRef } from "react";
import { escapeRegExp } from "@synthesis/shared-utils";
import { jsx } from "react/jsx-runtime";
//#region src/Select/local-components/MarkedText.tsx
const MarkedText = forwardRef((props, ref) => {
	const { text = "", search, width, ...other } = props;
	if (!search) return /* @__PURE__ */ jsx("span", {
		className: "w-1/3 overflow-hidden overflow-ellipsis whitespace-nowrap",
		style: { width: width ?? "100%" },
		ref,
		...other,
		children: text
	});
	const regexp = new RegExp(`(${escapeRegExp(search)})`, "ig");
	const parts = text.split(regexp);
	const normalizedSearch = search.toLowerCase();
	return /* @__PURE__ */ jsx("span", {
		className: "w-1/3 overflow-hidden overflow-ellipsis whitespace-nowrap",
		style: { width: width ?? "100%" },
		ref,
		...other,
		children: parts.map((part, index) => part.toLowerCase() === normalizedSearch ? /* @__PURE__ */ jsx("mark", {
			className: "text-brand-40 rounded bg-[#ffe7e6]",
			children: part
		}, index) : /* @__PURE__ */ jsx("span", { children: part }, index))
	});
});
MarkedText.displayName = "SelectMarkedText";
//#endregion
export { MarkedText };

//# sourceMappingURL=MarkedText.js.map